export const breadcrumbItemsPac = [
    { label: 'Inicio', url: '/' },
    { label: 'Recaudacion masiva', url: `/recaudacionMasiva` },
    { label: 'Archivo PAC', active: true },
]

export const breadcrumbItemsPat = [
    { label: 'Inicio', url: '/' },
    { label: 'Recaudacion masiva', url: `/recaudacionMasiva` },
    { label: 'Archivo PAT', active: true },
]